import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import Table from '../../../shared/elements/table/Table';
import IconContainer from '../../../shared/elements/icon/Icon';
import useExtraWorkEntriesState from './ExtraWorkEntriesState';
import AddExtraWorkEntry from './AddExtraWorkEntry';
import ShowExtraWorkEntries from './ShowExtraWorkEntries';
import {FormSelect} from '../../../shared/form/form-control/FormSelect';
import useCustomer from '../customers/CustomerState';
import {FormGroup} from '../../../shared/form/form-features/FormGroup';
import EditExtraWorkEntry from './EditExtraWorkEntry';

moment.locale('nl');

const months = _.map(_.range(-36, 1), (month) => ({
    month: moment().startOf('month').add(month, 'months').format('MMMM'),
    year: moment().startOf('month').add(month, 'months').format('YYYY'),
}));

const monthNow = {
    month: moment().startOf('month').format('MMMM'),
    year: moment().startOf('month').format('YYYY'),
};

const ExtraWorkEntriesTabView = ({selectedCustomer, t}) => {
    const {customer, loading: loadingCustomers} = useCustomer(selectedCustomer.customerId, t);
    const [month, setMonth] = useState(monthNow.month + ' ' + monthNow.year);
    const {
        monthExtraWorks,
        loadingMonth: loadingMonthExtraWorks,
        reloadMonth,
    } = useExtraWorkEntriesState(selectedCustomer.customerId, month, t);
    const [ewiBeingEdited, setEwiBeingEdited] = useState(null);

    useEffect(() => {
        setEwiBeingEdited(null);
    }, [selectedCustomer.customerId]);

    if (loadingCustomers || loadingMonthExtraWorks) return <>{t('general.Loading')}</>;

    return (
        <Wrapper>
            <div>
                <TitleContainer>
                    <label>{t('customer.ExtraWorkOverview')}</label>
                </TitleContainer>
                <SelectContainer>
                    <FormSelect defaultValue={month} onChange={(evt) => setMonth(evt.target.value)}>
                        {months.map((month, index) => {
                            return (
                                <option value={month.month + ' ' + month.year} key={index}>
                                    {month.month} {month.year}
                                </option>
                            );
                        })}
                    </FormSelect>
                </SelectContainer>
                <ShowExtraWorkEntries
                    extraWorks={monthExtraWorks}
                    reloadMonth={reloadMonth}
                    ewiBeingEdited={ewiBeingEdited}
                    onStartEdit={(ewiId) => setEwiBeingEdited(ewiId)}
                    customer={customer}
                />
            </div>

            <TitleContainer>
                <label>{ewiBeingEdited ? t('customer.EditExtraWork') : t('customer.AddExtraWork')}</label>
            </TitleContainer>
            {ewiBeingEdited ? (
                <EditExtraWorkEntry
                    extraWorkEntry={_.find(monthExtraWorks, {id: ewiBeingEdited})}
                    customer={customer}
                    onSave={() => {
                        reloadMonth();
                        setEwiBeingEdited(null);
                    }}
                    onCancel={() => setEwiBeingEdited(null)}
                />
            ) : (
                <AddExtraWorkEntry customer={customer} reloadMonth={reloadMonth} />
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    ${Table.Data} ${IconContainer} svg {
        width: 12px;
        padding: 1px 0 3px;
    }
    > div:first-of-type {
        margin-bottom: 60px;
    }
`;

const SelectContainer = styled.div`
    ${FormGroup} {
        width: 280px;
    }
`;

const TitleContainer = styled.div`
    *,
    label {
        font-size: 26px;
        font-weight: 600;
    }
`;

export default withTranslation()(ExtraWorkEntriesTabView);
